<script>
import {compile, h} from 'vue'

const TemplateCompiler = (props) => {
  return h(compile(props.template))
}

export default TemplateCompiler
</script>
